module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-09-19 at 4.37.33 PM.b7cf47f1.jpeg";